module.exports = __webpack_public_path__ + "1e845d850e6a9b6f36c2ef1dd4d2a358.svg";